var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_015",
    "data-name": 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.8,214.81H21.2a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46H378.8a.47.47,0,0,1,.46.46A.46.46,0,0,1,378.8,214.81Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,90.41H140.72a6.59,6.59,0,0,0-6.67,7.68l16.4,125a9,9,0,0,0,8.69,7.68H330.55a6.59,6.59,0,0,0,6.67-7.68l-16.4-125A9,9,0,0,0,312.13,90.41Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.55,231.22H159.14a9.5,9.5,0,0,1-9.13-8.07l-16.4-125a7.21,7.21,0,0,1,1.66-5.8A7.1,7.1,0,0,1,140.72,90H312.13A9.5,9.5,0,0,1,321.26,98l16.4,125a7.21,7.21,0,0,1-1.66,5.8A7.1,7.1,0,0,1,330.55,231.22ZM140.72,90.85a6.23,6.23,0,0,0-4.78,2.08A6.38,6.38,0,0,0,134.48,98l16.4,125a8.6,8.6,0,0,0,8.26,7.3H330.55a6.23,6.23,0,0,0,4.78-2.08,6.34,6.34,0,0,0,1.46-5.11l-16.4-125a8.6,8.6,0,0,0-8.26-7.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,110.32h189L295.79,223.1a9.46,9.46,0,0,1-9,7.68H113.21a6.33,6.33,0,0,1-6.4-7.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82,231.24H113.21a6.88,6.88,0,0,1-5.37-2.38,7.06,7.06,0,0,1-1.48-5.84L125.2,110.25a.46.46,0,0,1,.45-.38h189a.48.48,0,0,1,.35.16.49.49,0,0,1,.1.37L296.24,223.17A10,10,0,0,1,286.82,231.24ZM126,110.78,107.26,223.17a6.19,6.19,0,0,0,1.27,5.1,6,6,0,0,0,4.68,2H286.82a9,9,0,0,0,8.52-7.3l18.75-112.24Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,90.41H310.27a6.33,6.33,0,0,1,6.4,7.68l-2,12.22h-189l2-12.22A9.45,9.45,0,0,1,136.66,90.41Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,110.77h-189a.43.43,0,0,1-.35-.17.41.41,0,0,1-.1-.37l2-12.21A9.93,9.93,0,0,1,136.66,90H310.27a6.91,6.91,0,0,1,5.38,2.38,7.06,7.06,0,0,1,1.47,5.84l-2,12.21A.45.45,0,0,1,314.63,110.77Zm-188.44-.92H314.25l2-11.83a6.16,6.16,0,0,0-1.27-5.1,6,6,0,0,0-4.68-2H136.66a9,9,0,0,0-8.51,7.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,214h-.08a.45.45,0,0,1-.37-.52l15.14-90.63a.47.47,0,0,1,.53-.38.46.46,0,0,1,.37.53l-15.14,90.63A.46.46,0,0,1,141.92,214Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,214h-.08a.45.45,0,0,1-.38-.52l15.15-90.63a.46.46,0,1,1,.9.15l-15.15,90.63A.45.45,0,0,1,167.24,214Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,214h-.07a.45.45,0,0,1-.38-.52l15.14-90.63a.47.47,0,0,1,.53-.38.45.45,0,0,1,.37.53L193,213.63A.46.46,0,0,1,192.55,214Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.87,214h-.08a.44.44,0,0,1-.37-.52l15.14-90.63a.46.46,0,1,1,.9.15l-15.14,90.63A.46.46,0,0,1,217.87,214Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,214h-.07a.45.45,0,0,1-.38-.52l15.15-90.63a.46.46,0,1,1,.9.15l-15.15,90.63A.46.46,0,0,1,243.18,214Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,214h-.08a.45.45,0,0,1-.37-.52l15.14-90.63a.46.46,0,1,1,.9.15L269,213.63A.46.46,0,0,1,268.5,214Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,214h-.08a.45.45,0,0,1-.37-.52l15.14-90.63a.47.47,0,0,1,.53-.38.46.46,0,0,1,.37.53l-15.14,90.63A.46.46,0,0,1,141.92,214Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,214h-.08a.45.45,0,0,1-.38-.52l15.15-90.63a.46.46,0,1,1,.9.15l-15.15,90.63A.45.45,0,0,1,167.24,214Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,214h-.07a.45.45,0,0,1-.38-.52l15.14-90.63a.47.47,0,0,1,.53-.38.45.45,0,0,1,.37.53L193,213.63A.46.46,0,0,1,192.55,214Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.87,214h-.08a.44.44,0,0,1-.37-.52l15.14-90.63a.46.46,0,1,1,.9.15l-15.14,90.63A.46.46,0,0,1,217.87,214Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,214h-.07a.45.45,0,0,1-.38-.52l15.15-90.63a.46.46,0,1,1,.9.15l-15.15,90.63A.46.46,0,0,1,243.18,214Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,214h-.08a.45.45,0,0,1-.37-.52l15.14-90.63a.46.46,0,1,1,.9.15L269,213.63A.46.46,0,0,1,268.5,214Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.37,144.39H134.31a.46.46,0,1,1,0-.91H299.37a.46.46,0,1,1,0,.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,168.69H130.25a.46.46,0,1,1,0-.91H295.31a.46.46,0,1,1,0,.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.25,193H126.19a.46.46,0,0,1,0-.92H291.25a.46.46,0,0,1,0,.92Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.31,
    y1: 143.93,
    x2: 299.37,
    y2: 143.93,
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.37,144.39H134.31a.46.46,0,1,1,0-.91H299.37a.46.46,0,1,1,0,.91Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.25,
    y1: 168.24,
    x2: 295.31,
    y2: 168.24,
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,168.69H130.25a.46.46,0,1,1,0-.91H295.31a.46.46,0,1,1,0,.91Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.19,
    y1: 192.54,
    x2: 291.25,
    y2: 192.54,
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.25,193H126.19a.46.46,0,0,1,0-.92H291.25a.46.46,0,0,1,0,.92Z",
    fill: "none",
    stroke: "#d1d3d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.35,163.62a.44.44,0,0,1-.35-.16.46.46,0,0,1,.06-.64l17.65-14.69a.46.46,0,0,1,.64.06.47.47,0,0,1-.06.65l-17.64,14.68A.47.47,0,0,1,181.35,163.62Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.54,163.62a.46.46,0,0,1-.34-.15l-12.74-14.69a.46.46,0,0,1,0-.64.44.44,0,0,1,.64.05l12.74,14.68a.46.46,0,0,1,0,.64A.41.41,0,0,1,196.54,163.62Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.69,189.28a.46.46,0,0,1-.35-.17.45.45,0,0,1,.06-.64L271,173.79a.46.46,0,1,1,.59.7L254,189.17A.46.46,0,0,1,253.69,189.28Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.88,189.28a.44.44,0,0,1-.34-.16L255.8,174.44a.46.46,0,0,1,0-.65.47.47,0,0,1,.65.05l12.73,14.68a.46.46,0,0,1,0,.65A.48.48,0,0,1,268.88,189.28Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.88,230.42l24.53-19.19H283.22a8.78,8.78,0,0,0-8.32,7.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.88,230.88a.46.46,0,0,1-.23-.06.47.47,0,0,1-.22-.47l2-12.06a9.26,9.26,0,0,1,8.77-7.51h14.19a.44.44,0,0,1,.43.31.43.43,0,0,1-.15.5l-24.52,19.19A.46.46,0,0,1,272.88,230.88Zm10.34-19.19a8.31,8.31,0,0,0-7.87,6.75l-1.82,10.9,22.56-17.65Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.77,104.92a2,2,0,0,1-1-.27,12.5,12.5,0,1,1,17.52-16.29,2,2,0,0,1-3.6,1.76,8.5,8.5,0,0,0-16.14,3.72,8.54,8.54,0,0,0,4.23,7.36,2,2,0,0,1-1,3.72Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,104.92a2,2,0,0,1-1-.27,12.5,12.5,0,0,1,6.28-23.31,12.43,12.43,0,0,1,11.24,7,2,2,0,0,1-3.6,1.76,8.5,8.5,0,0,0-16.14,3.72,8.53,8.53,0,0,0,4.24,7.36,2,2,0,0,1-1,3.72Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,104.92a1.91,1.91,0,0,1-1-.27A12.5,12.5,0,1,1,187.3,88.36a2,2,0,1,1-3.59,1.76,8.5,8.5,0,0,0-16.15,3.72,8.55,8.55,0,0,0,4.24,7.36,2,2,0,0,1-1,3.72Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,87.48a.54.54,0,0,1-.25-.06.51.51,0,0,1-.19-.69,9.66,9.66,0,0,1,3.85-3.39.5.5,0,1,1,.42.9,8.92,8.92,0,0,0-3.4,3A.5.5,0,0,1,167,87.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.57,87.48a.5.5,0,0,1-.43-.75A9.6,9.6,0,0,1,216,83.34a.5.5,0,0,1,.66.24.49.49,0,0,1-.24.66,8.92,8.92,0,0,0-3.4,3A.5.5,0,0,1,212.57,87.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.08,87.48a.57.57,0,0,1-.25-.06.51.51,0,0,1-.18-.69,9.66,9.66,0,0,1,3.84-3.39.5.5,0,0,1,.67.24.49.49,0,0,1-.24.66,8.92,8.92,0,0,0-3.4,3A.52.52,0,0,1,257.08,87.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.89,
    y: 102.32,
    width: 23.06,
    height: 114.34,
    transform: "translate(-8.1 2.79) rotate(-2.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,217.64a.46.46,0,0,1-.46-.44L35.52,103a.44.44,0,0,1,.11-.33.47.47,0,0,1,.32-.16l23-1.18a.48.48,0,0,1,.49.44L65.32,216a.41.41,0,0,1-.12.33.43.43,0,0,1-.32.16l-23,1.18ZM36.46,103.42l5.81,113.27,22.11-1.13L58.57,102.29Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.83,
    y: 102.99,
    width: 3.08,
    height: 114.34,
    transform: "matrix(-1, 0.05, -0.05, -1, 82.89, 318.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.76,217.79a.51.51,0,0,1-.31-.11.5.5,0,0,1-.15-.32L32.45,103.17a.45.45,0,0,1,.11-.34.5.5,0,0,1,.32-.15l3.07-.16a.48.48,0,0,1,.49.44l5.85,114.19a.47.47,0,0,1-.44.49l-3.07.15ZM33.39,103.58,39.2,216.85l2.15-.11L35.54,103.47Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.96,
    y1: 109.09,
    x2: 41.29,
    y2: 108.86,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,109.55a.46.46,0,0,1,0-.92l4.34-.23a.46.46,0,0,1,.48.44.45.45,0,0,1-.43.48l-4.34.23Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.35,
    y1: 116.76,
    x2: 41.85,
    y2: 116.52,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.35,117.22a.47.47,0,0,1-.46-.44.45.45,0,0,1,.44-.48l4.49-.24a.48.48,0,0,1,.49.44.46.46,0,0,1-.44.48l-4.5.24Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.74,
    y1: 124.42,
    x2: 45.3,
    y2: 124.04,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.74,124.89a.47.47,0,0,1,0-.93l7.56-.38a.46.46,0,0,1,.48.43.47.47,0,0,1-.43.49l-7.56.38Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.14,
    y1: 132.09,
    x2: 42.47,
    y2: 131.87,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.14,132.55a.45.45,0,0,1-.46-.43.46.46,0,0,1,.43-.49l4.34-.22a.46.46,0,0,1,.48.44.45.45,0,0,1-.43.48l-4.34.22Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.53,
    y1: 139.76,
    x2: 43.12,
    y2: 139.53,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,140.22a.46.46,0,0,1-.46-.43.47.47,0,0,1,.44-.49l4.59-.23a.46.46,0,0,1,0,.92l-4.6.23Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.92,
    y1: 147.43,
    x2: 46.48,
    y2: 147.05,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.92,147.89a.47.47,0,0,1-.46-.43.47.47,0,0,1,.44-.49l7.56-.38a.45.45,0,0,1,.48.43.47.47,0,0,1-.44.49l-7.55.38Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.56,
    y: 131.32,
    width: 9.61,
    height: 94.16,
    transform: "translate(15.83 -6.32) rotate(4.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.05,226.19h0l-9.57-.83a.45.45,0,0,1-.31-.16.48.48,0,0,1-.11-.34L79.21,131a.48.48,0,0,1,.5-.42l9.58.84a.45.45,0,0,1,.41.5l-8.19,93.81A.46.46,0,0,1,81.05,226.19ZM72,224.47l8.65.76,8.12-92.89-8.66-.76Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.25,131.92a7.93,7.93,0,0,1-4.87,1.29,5.63,5.63,0,0,1-4.71-2.13l3.59-9.17,2.62-6.68,1.42,7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,133.68a6,6,0,0,1-5.09-2.35.45.45,0,0,1-.05-.42l6.21-15.85a.44.44,0,0,1,.47-.29.47.47,0,0,1,.41.37l3.37,16.68a.48.48,0,0,1-.16.45C89.48,132.33,87.83,133.68,84.38,133.68ZM80.19,131a5.35,5.35,0,0,0,4.19,1.74,8.29,8.29,0,0,0,4.36-1l-3-14.86Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.3 122.26 83.26 121.91 85.88 115.23 87.3 122.26",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3,122.72h0l-4-.35a.47.47,0,0,1-.34-.22.44.44,0,0,1,0-.4l2.61-6.69a.45.45,0,0,1,.47-.29.46.46,0,0,1,.4.37l1.43,7a.46.46,0,0,1-.45.55Zm-3.39-1.21,2.82.25-1-4.92Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 129.11,
    width: 7.56,
    height: 74.1,
    transform: "translate(14.72 -5.42) rotate(4.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.13,203.86h0l-7.54-.66a.45.45,0,0,1-.41-.5l6.44-73.82a.47.47,0,0,1,.5-.42l7.54.66a.47.47,0,0,1,.31.16.45.45,0,0,1,.11.34l-6.45,73.82a.44.44,0,0,1-.17.31A.44.44,0,0,1,70.13,203.86Zm-7-1.54,6.62.58L76.08,130l-6.62-.57Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.58,129.57a4.44,4.44,0,0,1-3.68,1.52A5.52,5.52,0,0,1,69,128.91l2.83-7.21,2-5.26L75.05,122Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.19,131.56h-.31a6,6,0,0,1-4.21-2.37.47.47,0,0,1-.06-.43l4.89-12.48A.44.44,0,0,1,74,116a.47.47,0,0,1,.42.37L77,129.48a.44.44,0,0,1-.08.37A4.89,4.89,0,0,1,73.19,131.56Zm-3.62-2.73a5,5,0,0,0,3.36,1.8,3.93,3.93,0,0,0,3.15-1.19l-2.3-11.37Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.05 121.98 71.87 121.7 73.92 116.44 75.05 121.98",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,122.44h0l-3.17-.28a.42.42,0,0,1-.35-.22.46.46,0,0,1,0-.41l2.06-5.26A.44.44,0,0,1,74,116a.47.47,0,0,1,.42.37l1.12,5.54a.46.46,0,0,1-.11.4A.49.49,0,0,1,75,122.44Zm-2.52-1.14,2,.17-.69-3.4Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9,
    y1: 131.09,
    x2: 66.4,
    y2: 203.16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4,203.62h0a.45.45,0,0,1-.42-.5l6.5-72.07a.5.5,0,0,1,.5-.42.47.47,0,0,1,.42.51l-6.5,72.07A.45.45,0,0,1,66.4,203.62Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.81,
    y: 149.2,
    width: 8,
    height: 28.19,
    transform: "translate(6.43 -2.17) rotate(2.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25,178h0l-8-.32a.42.42,0,0,1-.32-.14.46.46,0,0,1-.13-.33L54.91,149a.47.47,0,0,1,.47-.44l8,.31a.48.48,0,0,1,.45.48l-1.11,28.16A.46.46,0,0,1,62.25,178Zm-7.51-1.22,7.07.28,1.07-27.24-7.07-.28Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.31,
    y: 121.03,
    width: 11.21,
    height: 28.19,
    transform: "translate(5.33 -2.24) rotate(2.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,149.89h0l-11.2-.44a.48.48,0,0,1-.32-.15.45.45,0,0,1-.12-.33l1.1-28.16a.49.49,0,0,1,.48-.45l11.2.44a.48.48,0,0,1,.32.15.45.45,0,0,1,.12.33l-1.1,28.16A.46.46,0,0,1,65,149.89Zm-10.72-1.34,10.28.4,1.06-27.25-10.28-.4Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,146.26h0a.46.46,0,0,1-.44-.47l.76-19.59a3.45,3.45,0,0,1,3.58-3.3l.54,0a.46.46,0,0,1,0,.92h0l-.54,0a2.51,2.51,0,0,0-2.62,2.41l-.76,19.59A.46.46,0,0,1,50.2,146.26Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.93,151.83H93L89.35,227a7.48,7.48,0,0,1-7.48,7.47H41.09A7.47,7.47,0,0,1,33.62,227Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.87,234.93H41.09A7.94,7.94,0,0,1,33.16,227l-3.69-75.14a.48.48,0,0,1,.46-.49H93a.45.45,0,0,1,.33.15.43.43,0,0,1,.13.34L89.81,227A7.94,7.94,0,0,1,81.87,234.93ZM30.42,152.29,34.08,227a7,7,0,0,0,7,7H81.87a7,7,0,0,0,7-7l3.67-74.71Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85,166H31.26a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46H91.85a.46.46,0,0,1,.46.46A.45.45,0,0,1,91.85,166Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.82,
    y: 115.89,
    width: 42.66,
    height: 42.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.49,158.63H337.82a.47.47,0,0,1-.46-.46V115.89a.47.47,0,0,1,.46-.46h42.67a.47.47,0,0,1,.46.46v42.28A.47.47,0,0,1,380.49,158.63Zm-42.2-.92H380V116.35H338.29Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.67,
    y: 108.99,
    width: 7.76,
    height: 11.98,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,126.12H350.76a.46.46,0,1,1,0-.92h22.83a.46.46,0,0,1,0,.92Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,134.13h-29.3a.46.46,0,0,1,0-.92h29.3a.46.46,0,1,1,0,.92Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.81,142.14H344.29a.46.46,0,0,1,0-.92h29.52a.46.46,0,1,1,0,.92Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37,150.15H344.29a.46.46,0,0,1,0-.92h18.08a.46.46,0,0,1,0,.92Z",
    fill: "#d1d3d4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.25016b3118ffb2d12a638ec1c6bc5529.svg";
export { ForwardRef as ReactComponent };